import { useEffect, useRef, useState } from 'react';
import cn from '@utils/cn';
import limitNum from '@utils/limitNum';
import { roundNum } from '@utils/roundNum';

interface Props {
  min: number;
  max: number;
  value: number;
  digits?: number;
  className?: string;
  onChange: (val: number) => void;
}
export function NumInput({
  className,
  value,
  min,
  max,
  digits = 0,
  onChange,
}: Props) {
  const [inputMode, setInputMode] = useState<boolean>(false);
  const inputRef = useRef<HTMLInputElement>(null);

  useEffect(() => {
    if (inputMode && inputRef.current) {
      setTimeout(() => {
        inputRef.current?.select();
      }, 10);
    }
  }, [inputMode]);

  const handleDone = (val: string) => {
    setInputMode(false);
    onChange(
      roundNum(
        digits,
        limitNum({
          min,
          max,
          value: Number(val),
        })
      )
    );
  };

  if (inputMode) {
    return (
      <input
        type="number"
        className={cn(
          'h-30 rounded border border-dark bg-black text-white focus:outline-none focus:ring-2 focus:ring-blue',
          className
        )}
        ref={inputRef}
        defaultValue={value}
        onKeyUp={(e) => {
          if (e.key === 'Enter') {
            handleDone((e.target as HTMLInputElement).value.trim());
          } else if (e.key === 'Escape') {
            setInputMode(false);
          }
        }}
        onBlur={(e) => {
          handleDone(e.target.value.trim());
        }}
      />
    );
  }

  return (
    <div
      className={cn(
        'flex h-30 items-center rounded border border-dark bg-black text-white focus:outline-none focus:ring-2 focus:ring-blue',
        className
      )}
      onClick={() => {
        setInputMode(true);
      }}
    >
      {value}
    </div>
  );
}

export default NumInput;
